<template>
  <b-modal id="ncmNaoEncontrada" centered ref="ncmNaoEncontrada" size="md" hide-footer hide-header>
    <div class="text-center mb-5">
      <i class="fas fa-times text-danger icone"></i>
    </div>
    <h4 class="text-center mb-3">
      Opa, parece que essa NCM não existe
      <i class="far fa-frown"></i>
    </h4>
    <p class="text-center">Certifique-se do que você procura está certo e tente novamente.</p>
    <div class="text-center">
      <b-button
        class="text-center"
        variant="danger"
        @click="$bvModal.hide('ncmNaoEncontrada')"
      >Voltar</b-button>
    </div>
  </b-modal>
</template>

<script>
export default {};
</script>

<style scoped>
.icone {
  font-size: 70px;
  border-radius: 100%;
  border: 6px solid #dc3545;
  padding: 10px 20px;
}
</style>